import { GetCompanyQuery } from "@/graphql/generated/graphql";
import { Unpacked } from "@/helpers/types/types.helpers";
import { Slice } from "../store.decl";

export type CompanyTag = Unpacked<GetCompanyQuery["getCompany"]["tags"]>;

export type CompanyTagsSliceState = {
  companyTags: CompanyTag[];
  setCompanyTags: (tags: CompanyTag[]) => void;
};

export const createCompanyTagsSlice: Slice<CompanyTagsSliceState> = (set) => ({
  companyTags: [],
  setCompanyTags: (companyTags) => {
    set(() => ({
      companyTags,
    }));
  },
});
